// Shared Tailwind class constants for dashboard pie-chart cards.

export const pieCardClasses =
    'bg-surface-alt rounded-lg p-4 shadow-[0_1px_3px_rgba(0,0,0,0.1)] ' +
    'h-90 flex flex-col';

export const pieViewAllClasses =
    'text-sm text-primary cursor-pointer font-heading font-semibold leading-5';

export const pieContentClasses = 'flex-1 flex items-center';

export const pieChartWrapperClasses = 'flex-1 flex items-center justify-center';

export const pieLegendClasses = 'flex-1';

export const pieLegendItemClasses = 'flex items-center mb-3 text-sm';

export const pieLegendDotClasses = 'w-2.5 h-2.5 rounded-full mr-2';

export const pieLegendTextClasses = 'truncate';

export const pieNoDataClasses =
    'flex items-center justify-center h-60 w-[46%] text-base text-subtle';

// Stone rounded card used as a generic dashboard stat container.
export const statCardClasses =
    'flex flex-col p-4 gap-4 rounded-lg bg-surface-alt';

// Page container for super-admin dashboards (formerly `.dashboard-list`).
export const dashboardListClasses =
    'bg-surface p-6 max-w-350 rounded-lg ' +
    'max-[1400px]:max-w-[1350px]!';

// Heading style for super-admin dashboard pages (formerly `.dashboard-title`).
export const dashboardTitleClasses =
    "text-content font-serif text-section-title";
